<template>
    <el-row class="reOrders">
      <el-row class="cardContent">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <el-page-header @back="goBack" content="问题搜索"></el-page-header>
          </div>
          <div class="search">
            <div class="ser_left">
              <el-input clearable placeholder="请输入内容" v-model="keywords"  @change="keyupEvent" class="input-with-select"></el-input>
              <el-button type="primary" @click="search">搜索</el-button>
            </div>
            <div class="ser_right" v-show="isShow">
              共为你找到{{ total }}条相关结果
            </div>
          </div>
          <el-divider></el-divider>
          <el-empty v-if="isHaveShow" :image-size="1"></el-empty>
          <div class="text item">
            <div class="mains" v-for="item in searchArr" :key="item.category_id">
               <div @click="goDetail(item)">
                  <h3>{{ item.goods_model + item.title }}</h3>
                  <div class="content">{{ item.description }}</div>
                  <el-divider content-position="right">{{ item.create_time }}</el-divider>
               </div>
            </div>
          </div>
          <div class="drawer">
            <el-drawer
              size="50%"
              title="问题详情"
              :visible.sync="drawer"
              :direction="direction"
              :before-close="handleClose">
              <el-row>
                  <el-card class="box-card">
                      <div class="content">
                          <el-descriptions class="margin-top" :column="1" size="medium" border :labelStyle="labelStyle" :contentStyle="contentStyle">
                              <el-descriptions-item label-class-name="my-label">
                                  <template slot="label">
                                      问题题目:
                                  </template>
                                  {{ qsData.title }}
                              </el-descriptions-item>
                              <el-descriptions-item>
                                  <template slot="label">
                                      型号:
                                  </template>
                                  {{ qsData.goods_model }}
                              </el-descriptions-item>
                              <el-descriptions-item>
                                  <template slot="label">
                                      最后修改时间:
                                  </template>
                                  {{ qsData.create_time }}
                              </el-descriptions-item>
                              <el-descriptions-item>
                                  <template slot="label">
                                      入库人:
                                  </template>
                                  {{ qsData.publish_person_name }}
                              </el-descriptions-item>
                              <el-descriptions-item>
                                  <template slot="label">
                                      工单类型:
                                  </template>
                                  <el-tag size="small">{{ qsData.type }}</el-tag>
                              </el-descriptions-item>
                              <el-descriptions-item>
                                  <template slot="label">
                                      文件:
                                  </template>
                                  <div class="file">
                                      <a v-for="val in fileList" :key="val.id" @click="downLoadFile(val.url)" style="display: flex;">
                                          <div class="item"  v-if="val.url.split('.')[val.url.split('.').length-1]=='txt'">
                                              <div>                                    
                                                  <el-image :src = "require('../../assets/filetype/txt.jpg')"></el-image>
                                              </div>
                                              <div class="name">{{ val.name }}</div>
                                          </div>
                                          <div class="item"  v-if="val.url.split('.')[val.url.split('.').length-1]=='ppt' || val.url.split('.')[val.url.split('.').length-1] ==  'pptx'">
                                              <div>                                    
                                                  <el-image :src = "require('../../assets/filetype/ppt.jpg')"></el-image>
                                              </div>
                                              <div class="name">{{ val.name }}</div>
                                          </div>
                                          <div class="item"  v-if="val.url.split('.')[val.url.split('.').length-1]=='pdf'">
                                              <div>                                    
                                                  <el-image :src = "require('../../assets/filetype/pdf.png')"></el-image>
                                              </div>
                                              <div class="name">{{ val.name }}</div>
                                          </div>
                                          <div class="item"  v-if="val.url.split('.')[val.url.split('.').length-1]=='xlsx' || val.url.split('.')[val.url.split('.').length-1]=='xls'">
                                              <div>                                    
                                                  <el-image :src = "require('../../assets/filetype/excel.jpg')"></el-image>
                                              </div>
                                              <div class="name">{{ val.name }}</div>
                                          </div>
                                          <div class="item"  v-if="val.url.split('.')[val.url.split('.').length-1]=='docx' || val.url.split('.')[val.url.split('.').length-1]=='doc'">
                                              <div>                                    
                                                  <el-image :src = "require('../../assets/filetype/word.jpg')"></el-image>
                                              </div>
                                              <div class="name">{{ val.name }}</div>
                                          </div>
                                          <div class="item"  v-if="val.url.split('.')[val.url.split('.').length-1]=='avi'">
                                              <div>                                    
                                                  <el-image :src = "require('../../assets/filetype/avi.jpg')"></el-image>
                                              </div>
                                              <div class="name">{{ val.name }}</div>
                                          </div>
                                          <div class="item"  v-if="val.url.split('.')[val.url.split('.').length-1]=='7z' || val.url.split('.')[val.url.split('.').length-1]=='rar'">
                                              <div>                                    
                                                  <el-image :src = "require('../../assets/filetype/zip.png')"></el-image>
                                              </div>
                                              <div class="name">{{ val.name }}</div>
                                          </div>
                                          <div class="item"  v-if="val.url.split('.')[val.url.split('.').length-1]=='mp4' || val.url.split('.')[val.url.split('.').length-1]=='mov' ||val.url.split('.')[val.url.split('.').length-1]=='ogg' || val.url.split('.')[val.url.split('.').length-1]=='webm'">
                                              <div>                                    
                                                  <el-image :src = "require('../../assets/filetype/video.jpg')"></el-image>
                                              </div>
                                              <div class="name">{{ val.name }}</div>
                                          </div>
                                      </a>
                                  </div>
                              </el-descriptions-item>
                          </el-descriptions>
                      </div>
                    
                      <div class="detail">
                          <div class="title">详情</div>
                          <el-divider></el-divider>
                          <div class="content" v-html="qsData.detail"></div>
                      </div>
                    
                  </el-card>
              </el-row>
            </el-drawer>
          </div>
          <div class="pages">
            <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                :page-size="pageSize"
                @current-change="currentClick">
            </el-pagination>
          </div>
      </el-card>
      </el-row>
      <el-row class="continue" v-show="isShow">
          <span>以上回答是否能解决您的问题？</span>
          <el-button type="text" size="medium"  @click='goPublish'>没有解决?点击继续提交工单</el-button>
      </el-row>
    </el-row>
</template>

<script>
import { questionSearch,quesDetail,getinsertQuestionSearch } from '../../utils/api'
export default {
  components: {},
  props: {},
  data() {
    return {
        total:0,
        page:1,
        pageSize:5,
        keywords:"",
        searchArr:[],
        isShow:false,
        isHaveShow:false,
        direction:'rtl',
        drawer:false,
        id: '',
        videoSrc:'',
        videVisible:false,
        videoTitle:'',
        qsData: {},
        imgList:[],
        imgArr:[],
        fileList:[],
        updateTable:[],
        labelStyle:{
          width:'150px',
          background:'#fff',
          color:'#333'
        },
        contentStyle:{
          color:'#999'
        },
        urlHerf:localStorage.getItem('urlHerf')
    };
  },
  watch: {},
  computed: {},
  methods: {
    goBack(){
      this.$router.go(-1)
    },
    //搜索结果查询
    search(){
      var that = this
      var params = {
          page:that.page,
          pagesize:that.pageSize,
          keywords:that.keywords,
      }
      getinsertQuestionSearch(params)
      .then(res=>{
        console.log(res,'搜索结果');
        if(res.message.status == 'success'){
          that.searchArr = res.data
          that.searchArr.forEach(item=>{
            item.create_time = that.getTimeship(item.create_time)
          })
          that.total = res.total
          that.isShow = true
          that.isHaveShow = false
        }else{
          that.searchArr = []
          that.total = 0
          that.isShow = true
          that.isHaveShow = true
        }
      })
      .catch(err=>{
        console.log(err,'err');
      })
    },
    helloworld(){
        alert('hello world');
    },
    //当前页
    currentClick(e){
      console.log(e,'当前页');
      var that = this
      that.page = e
      that.search()
    },
    //继续发布工单
    goPublish(){
      this.$router.push({name:'reOrdForm'})
    },
    goDetail(item){
      console.log(item,'item');
      // this.$router.push('/quesDetail?jumpId='+(item.id))
      this.id = item.id
      this.drawer = true
      this.getQs()
    },
    // 下载文件列表
    downLoadFile(val){
        if(val.split('.')[val.split('.').length-1]=='mp4'){
            console.log(val,'valvalvalvalvalval');
            return this.watchEvent(val)
        }
      let link = document.createElement("a")
      link.style.display = "none"
      link.href = val
      var arr = val.split("/")
      link.setAttribute("download",arr[arr.length-1])
      document.body.appendChild(link)
      link.click()
    },
    getQs() {
            var params = {
                id: this.id
            }
            quesDetail(params)
                .then(res => {
                    console.log(res, 'res');
                    if (res.message.status == 'success') {
                        this.qsData = res.data
                        this.qsData.create_time = this.getTimeship(this.qsData.create_time)
                        //图片
                        console.log(this.qsData.attach_image_info.length,'this.qsData.attach_image_info');
                        var imgList = []
                        var arr = []
                        this.imgList = []
                        imgList = this.qsData.attach_image_info
                        imgList.forEach(item=>{
                            item.url = this.urlHerf + item.url
                            arr.push(item)
                            this.imgArr.push(item.url)
                        })
                        this.imgList = arr
                        console.log(this.imgList,'this.imgList');

                        //文件
                        // console.log(this.qsData.attach_file_info.length,'this.qsData.attach_file_info.length');
                        var fileArr = this.qsData.attach_file_info
                        var arr1 = []
                        fileArr.forEach(ele =>{
                            ele.url = this.urlHerf + ele.url
                            arr1.push(ele)
                        })
                        this.fileList = arr1
                        console.log(this.fileList,'this.fileList');
                    } else {
                        this.$message.error(res.message.text)
                    }
                })
                .catch(err => {
                    console.log(err, 'err');
                })
    },
    getupdateTable(){
            var that = this
            var params = {
                question_id:this.id
            }
            updateTable(params)
            .then(res=>{
                console.log(res,'修改记录');
                if(res.message.status == 'success'){
                    that.updateTable = res.data
                    that.updateTable.forEach(item=>{
                        item.create_time = that.getTimeship(item.create_time)
                    })
                }
            })
            .catch(err=>{
                console.log(err,'err');
            })
    },
    //视频
    watchEvent(val){
          console.log(val,'val');
          this.videVisible = true
          this.videoSrc = val
          this.videoTitle = val.name
    },
    keyupEvent(){
      this.search()
    }
  },
  created() {},
  mounted() {},
  activated(){
    this.searchArr = []
    this.keywords = ''
    this.isShow = false
    this.isHaveShow = false
    this.total = 0
  }
};
</script>
<style lang="scss" scoped>
.reOrders{
  .cardContent{
    .search{
      width: 100%;
      display: flex;
      align-items: center;

      .ser_left{
        width: 50%;
        display: flex;
        button{
          margin-left: 10px;
        }
      }
      .ser_right{
        width: 50%;
        text-align: right;
      }
    }
    :deep(.text){
      margin-top: 30px;
      .mains{
        cursor: pointer;
        h3{
          font-size: 16px;
        }
        .content{
          font-size: 14px;
          // color: #666;
        }
      }
      .mains:hover{
        color: #409EFF !important;
      }
    }
    .pages{
      text-align: right;
    }
  }
}


.log-hight-light{
  color: red;
}

.detail{
    margin-top: 20px;
    .title{
        font-size: 16px;
    }
    :deep(.content){
        
        background: #f4f4f4;
        padding: 10px;
        border-radius: 5px;
        overflow-x: scroll;
        font-size: 14px;

        img{
          width: 100%;
        }
    }
}
.file{
    display: flex;
    a{
        width: 60px;
        margin-left: 5px;
        .item{
            width: 100%;
            font-size: 12px;
            .name{
                display:block;             /*内联对象需加*/
                width:100%;
                word-break:keep-all;       /* 不换行 */
                white-space:nowrap;        /* 不换行 */
                overflow:hidden;           /* 内容超出宽度时隐藏超出部分的内容 */
                text-overflow:ellipsis;    /*溢出时显示省略标记...；需与overflow:hidden;一起使用*/
            }
            .el-image{
                width: 100%;
            }
        }
    }
}
</style>